import "./Faq.css";
import { useState } from "react";
import faq from "../Images/faq.png";
import faqarrow from "../Images/faqarrow.png";

const   Faq = () => {
  const [active, setActive] = useState(1);
  const toggleActive = (id) => {
    setActive(active === id ? null : id);
  };
  const data = [
    {
      id: 1,
      heading: "What types of AR/VR experiences do you develop?",
      text: "Each solution is tailored to meet the unique needs of your business and users.",
    },
    {
      id: 2,
      heading: "Do you offer enterprise-grade AR/VR solutions?",
      text: "Yes. We craft scalable enterprise AR/VR solutions built for high performance, hassle-free integration, and future-proofing. Whether you require a mobile AR app or an enterprise VR training solution, we have you covered.",
    },
    {
      id: 3,
      heading: "What makes your AR/VR development services stand out?",
      text: "Our power is in the fusion of compelling storytelling with the latest technology. With a history of success in every industry, our solutions are designed not merely to wow but to achieve genuine business results such as enhanced training effectiveness, higher engagement, and deeper brand affinity",
    },
    {
      id: 4,
      heading: "Can you help us concept and strategize our AR/VR solution?",
      text: "Yes. We provide full-cycle services, beginning from strategy and ideation through development and deployment. We work closely with you to ensure that the solution is aligned with your objectives and the requirements of your users. ",
    },
    {
      id: 5,
      heading: "How do we get started with your AR/VR development services?",
      text: "Just contact us through our contact form or book a call. We'll guide you through the process, learn your objectives, and recommend a tailored approach to make your AR/VR dream a reality.",
    },
  ];
  return (
    <div id="faq" className="divWrapper">
      <div className="arvrcontainer faqContainer">
         <h2 className="heading">Frequently Asked Questions (FAQs)</h2>
        <div className="faqWrapper">
          <div className="faqImgbox">
            <img src={faq} alt="" className="faqimg" />
          </div>
          <div className="faqContent">
            {data.map((item) => {
              return (
                <div
                  className="faqbox"
                  key={item.id}
                  style={{ gap: active === item.id ? "" : "" }}
                >
                  <div
                    className={`faqheading ${active === item.id ? "open" : ""}`}
                     onClick={() => toggleActive(item.id)}
                  >
                    <p>{item.heading}</p>
                    <img
                      src={faqarrow}
                      alt=""
                      className="faqarrow"                     
                      style={{
                        transform:
                          active === item.id
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                      }}
                    />
                  </div>
                  <div
                    className={`faqbody${active === item.id ? " open" : ""}`}
                  >
                    {active === 1 && (
                      <>
                        <p className="extrap">
                          We specialize in custom AR/VR development, including:
                        </p>
                        <ul className="extraul">
                          <li>● VR training simulations</li>
                          <li>● Virtual classrooms</li>
                          <li>● VR-based retail experiences</li>
                        </ul>
                      </>
                    )}
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
